import PropTypes from "prop-types";
function CustomSpan(props) {
  const { text, className, onClick, children, title } = props;

  return (
    <span className={className} onClick={onClick} title={title}>
      {children ? children : text}
    </span>
  );
}

CustomSpan.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

export default CustomSpan;
